import { apiClient } from '../ruutsApi/client'
import endpoints from '../ruutsApi/endpoints'
import { unwrapVoid } from '../ruutsApi/normalize'

// PUT /v1/farmSubdivisions answers `{ message }` with no payload.
export const updateFarmSubdivision = async ({ farmSubdivision }) => {
  const response = await apiClient.put(endpoints.farmSubdivisions, {
    id: farmSubdivision.id,
    data: { ...farmSubdivision },
  })
  return unwrapVoid(response)
}
